import React, { Component } from 'react';
import Pagination from 'react-js-pagination';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Box from '../ui/Box';

import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';

import DataService from '../../services/DataService';
var dataService = DataService;

import LocalStorageService from '../../services/LocalStorageService';
var localStorage = LocalStorageService;

export default class GenerateNewToken extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isEnabled: false,
      allRooms: [],
      clientData: {},
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 10,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    this.verifyEnable();
    this.getAllRooms(this.state.current_offset);
  }

  verifyEnable() {
    dataService.getEnableStatus(
      data => {
        this.setState({
          isEnabled: data.success
        });
      },
      error => {
        console.log('Error = ', error);
      }
    );
  }

  getAllRooms(offset, offset_change = 0) {
    offset = this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0
    dataService.getRoomsTokens(10, offset,
      data => {

        for (let row of data) {

          if (row.oauth_token && row.oauth_token.expires) {
            let cell = row.oauth_token.expires;
            let x = new Date(cell);
            row.expireTime = x && x != 'Invalid Date' ? x.toDateString() + ', ' + x.toLocaleTimeString() : 'Unknown'

          } else {
            row.expireTime = 'NA';
          }

          if (row.oauth_token && row.oauth_token.access_token) {
            row.accessToken = row.oauth_token.access_token;
          }

        }

        this.setState({
          allRooms: data,
          totalCount: data.length
        });

        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {
        console.log(err);
      }

    );
  }

  handleCheckChanges(e) {
    this.setState({
      isEnabled: e.target.checked
    },
      () => {
        const apiObject = {
          enable_api_integration: this.state.isEnabled
        };
        dataService.postEnableIntegration(apiObject,
          data => {
            this.setState({
              clientData: data
            });

            if (data) {
              localStorage.setClientDetails(data);
            }
          },
          error => {
            console.log('Error = ', error);
          }
        );
      });
  }

  onChangePage(e) {
    this.getAllRooms(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  generateToken(room, e) {
    let clientData = this.state.clientData !== {} ? this.state.clientData : localStorage.getClientDetails();
    const tokenObject = {
      clientId: clientData.clientId,
      roomId: room._id
    };
    dataService.postGenerateToken(tokenObject,
      data => {
        this.getAllRooms();
      },
      error => {
        console.log('Error = ', error);
      }
    );
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
  }

  openLink(room, e) {
    this.setState({
      dialog: {
        head: 'Generated Token',
        body: <div><input id="accessToken" style={{ width: "100%", border: "none" }} value={room.accessToken}/></div>,
        open: true,
        actions: [

          <CopyToClipboard text={room.accessToken}
            onCopy={() => {
              this.closeDialog();
            }}>
            <FlatButton
              label="Copy"
              primary
            />
          </CopyToClipboard>,

          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    });
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)}
    />
    return (
      <div>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        {
          <Box header='New Token Generation'>
            <div className="smart-form">
              <fieldset>

                <section style={{ width: '50%' }}>
                  <Checkbox label="Enable API Integrations?" checked={this.state.isEnabled} onCheck={this.handleCheckChanges.bind(this)} />
                </section>

                {
                  this.state.isEnabled === true ?

                    <div className = "col-sm-12">

                      <section>
                        <div >
                          <i className="pull-right material-icons" 
                            style={{ float: 'right', marginTop: '-2.5rem', cursor: 'pointer' }}
                            onClick={this.getAllRooms.bind(this)}
                          >
                            autorenew
                          </i>
                        </div>
                      </section>

                      <section>
                        <Table
                          height={'45vh'}
                          fixedHeader={true}
                          fixedFooter={true}
                          selectable={false}
                          multiSelectable={false}
                          style={{ minWidth: 700 }}
                          bodyStyle={{ minWidth: 700, overflowX: 'auto' }}
                        >
                          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                              <TableHeaderColumn colSpan="5" className="align-center font-14px" 
                                style={{color:'black'}
                              }>
                                All Rooms in the Hotel
                              </TableHeaderColumn>
                            </TableRow>

                            <TableRow>
                              <TableHeaderColumn tooltip="Room Number">Room Number</TableHeaderColumn>
                              <TableHeaderColumn tooltip="Expiry Date">Expiry Date</TableHeaderColumn>
                              <TableHeaderColumn tooltip="Token">Token</TableHeaderColumn>
                              <TableHeaderColumn className="align-center"></TableHeaderColumn>
                            </TableRow>
                          </TableHeader>

                          <TableBody
                            displayRowCheckbox={false}
                            showRowHover={true}
                            stripedRows={false}
                          >
                            {
                              this.state.allRooms.map((row, index) => (
                                <TableRow key={index}>
                                  <TableRowColumn>{row.name ? row.name : ''}</TableRowColumn>
                                  <TableRowColumn>{row.expireTime ? row.expireTime : 'NA'}</TableRowColumn>
                                  <TableRowColumn>
                                    {
                                      row.accessToken ?
                                        row.accessToken
                                        :
                                        <FlatButton
                                          label="Generate Token"
                                          className="my-btn pull-right"
                                          onClick={this.generateToken.bind(this, row)}
                                          type="button"
                                        />
                                    }
                                  </TableRowColumn>
                                  <TableHeaderColumn className="v-center">
                                    {
                                      row.accessToken ? 
                                        <div><FlatButton label="Show Token" primary onClick={this.openLink.bind(this, row)} /><div className="divider" /></div>
                                      : null
                                    }
                                  </TableHeaderColumn>
                                </TableRow>
                              ))
                            }
                          </TableBody>

                          <TableFooter>
                            <TableRow>
                              <TableRowColumn colSpan="7" style={{ textAlign: 'center' }}></TableRowColumn>
                              <TableRowColumn colSpan="3" style={{ textAlign: 'right' }}>{pagination}</TableRowColumn>
                            </TableRow>
                          </TableFooter>
                        </Table>

                      </section>
                    </div>

                  : null

                }
              </fieldset>
            </div>
          </Box>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/integration/GenerateNewToken.js